import styled, { css } from 'styled-components'

import { QuantityBadgeColor, QuantityBadgeSize } from './quantity-badge.types'

const heightMap: Record<QuantityBadgeSize, string> = {
  medium: '2.4rem',
  small: '1.6rem',
}

export const QuantityBadge = styled.span<{
  $color: QuantityBadgeColor
  $size: QuantityBadgeSize
}>(({ theme, $color, $size }) => {
  const styles = {
    blue: css`
      color: ${theme.colors.blue500};
      background-color: ${theme.colors.blue100};
    `,
    gray: css`
      color: ${theme.colors.primary800};
      background-color: ${theme.colors.gray100};
    `,
    green: css`
      color: ${theme.colors.green500};
      background-color: ${theme.colors.green100};
    `,
    neutral: css`
      color: ${theme.colors.black500};
      background-color: ${theme.colors.gray300};
    `,
    orange: css`
      color: ${theme.colors.orange500};
      background-color: ${theme.colors.orange100};
    `,
    purple: css`
      color: ${theme.colors.purple500};
      background-color: ${theme.colors.purple100};
    `,
    red: css`
      color: ${theme.colors.red500};
      background-color: ${theme.colors.red100};
    `,
    turquoise: css`
      color: ${theme.colors.turquoise500};
      background-color: ${theme.colors.turquoise100};
    `,
    yellow: css`
      color: ${theme.colors.yellow500};
      background-color: ${theme.colors.yellow100};
    `,
  }

  return css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    flex-shrink: 0;
    min-width: 1.6rem;
    height: ${heightMap[$size]};
    padding: 0 ${theme.space['6']};
    margin-left: auto;
    border-radius: ${theme.border.radius.full};
    white-space: nowrap;
    font-size: 1.2rem;
    line-height: 1.6rem;
    font-weight: 500;
    letter-spacing: 0;

    ${styles[$color]}
  `
})
